__turbopack_context__.v({
  "bvMedia": "ProductCardBloodVisionSubscription-module__Rlfy0q__bvMedia",
  "pricing": "ProductCardBloodVisionSubscription-module__Rlfy0q__pricing",
  "root": "ProductCardBloodVisionSubscription-module__Rlfy0q__root",
  "specBlock": "ProductCardBloodVisionSubscription-module__Rlfy0q__specBlock",
});
